import { useState } from 'react'
import type { PortraitsPlacedFilter } from '@/lib/portraits/types/portraits-placed-filter'

/**
 * Same idea as `useTemplatesFilters` and `useClikArtFilters`, for Portraits' applied filters
 * (name search, grade, homeroom, custom group, Placed) — WMPCM-11026 AC-8. They live here, in the
 * parent that outlives `PortraitsPanel`'s unmount, so they survive the panel closing (icon click,
 * Escape or the rail toggle) and switching to another rail icon.
 *
 * Returns the controlled props for `PortraitsPanel`.
 */
export function usePortraitsFilters() {
  const [nameQuery, setNameQuery] = useState('')
  const [gradeId, setGradeId] = useState('')
  const [homeroomId, setHomeroomId] = useState('')
  const [customId, setCustomId] = useState('')
  const [placedFilter, setPlacedFilter] = useState<PortraitsPlacedFilter>('any')

  return {
    nameQuery,
    onNameQueryChange: setNameQuery,
    gradeId,
    onGradeIdChange: setGradeId,
    homeroomId,
    onHomeroomIdChange: setHomeroomId,
    customId,
    onCustomIdChange: setCustomId,
    placedFilter,
    onPlacedFilterChange: setPlacedFilter,
  }
}
